import { Button, Grid, LinearProgress } from '@material-ui/core';
import { createTheme, lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import axios from "axios";
import MaterialTable, { Localization } from 'material-table';
import moment from 'moment';
import React, { useEffect, useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import { API_URL, RE_LOGIN_MESSAGE } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';

const theme = createTheme({
  /*
  palette: {
    secondary: {
      main: "rgba(33, 150, 243, 1) !important",
    },
  },
  */
  overrides: {
    MuiTableRow: {
      hover: {
        "&:hover": {
          backgroundColor: "rgba(33, 150, 243, 0.25) !important"
        }
      }
    }
  }
});

const localizationJapanese: Localization = {
  error: "エラー",
  body: {
    emptyDataSourceMessage: "表示するレコードがありません。",
    filterRow: {
      filterTooltip: "フィルター",
    },
  },
  header: {
    actions: "アクション",
  },
  grouping: {
    groupedBy: "グループ化:",
    placeholder: "ヘッダーをドラッグ ...",
  },
  pagination: {
    firstTooltip: "最初のページ",
    firstAriaLabel: "最初のページ",
    previousTooltip: "前のページ",
    previousAriaLabel: "前のページ",
    nextTooltip: "次のページ",
    nextAriaLabel: "次のページ",
    labelDisplayedRows: "{from}-{to} 全{count}件",
    labelRowsPerPage: "ページあたりの行数:",
    lastTooltip: "最後のページ",
    lastAriaLabel: "最後のページ",
    labelRowsSelect: "件",
  },
  toolbar: {
    nRowsSelected: "{0} 行選択",
  },
};



const BorderLinearProgress1 = withStyles({
  root: {
    height: 30,
    width: 130,
    backgroundColor: lighten('#0000FF', 0.9),
  },
  bar: {
    backgroundColor: '#0000FF',
  },
})(LinearProgress);

const BorderLinearProgress2 = withStyles({
  root: {
    height: 30,
    width: 130,
    backgroundColor: lighten('#0000FF', 0.9),
  },
  bar: {
    backgroundColor: '#FFFF00',
  },
})(LinearProgress);

const BorderLinearProgress3 = withStyles({
  root: {
    height: 30,
    width: 130,
    backgroundColor: lighten('#0000FF', 0.9),
  },
  bar: {
    backgroundColor: '#FF0000',
  },
})(LinearProgress);

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  root: {
    flexGrow: 1,
  },
  margin: {
    margin: 10,
  },
  red: {
    backgroundColor: 'red',
  }
});

const Constructionlist: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  const history = useHistory();
  const classes = useStyles();
  const [posts, setPosts] = useState<any[]>([])
  const [storage_percentage, setStoragePercentage] = useState(0)
  const [hide, setCapacityColor] = useState(['', 'hide', 'hide'])
  const [constructionPosts, setConstructionPosts] = useState([{ construction_id: "" }])
  const [companyPosts, setCompanyPosts] = useState({ total_capacity: "" })




  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')

  // 工事データから利用容量を産出
  const sumFileSize = () => {
    let subtotal = 0
    constructionPosts.forEach(item => {
      let size = (item as any)?.storage_size
      if (!isNaN(size)) {
        subtotal += parseInt(size)
      }
    })
    return subtotal.toString()
  }


  useEffect(() => {
    openLoading()
    // 会社情報取得
    axios.post(API_URL.COMPANY_GET,
      {
        "company_id": jsonlist.user.company_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const company = res.data.data;
        setCompanyPosts(company)
        setConstructionPosts(company.dealer_info)
        setPosts(company.dealer_info)


        storageRecalc({ company: company })
      })
      .catch(error => {
        console.log(error)
        // ここでエラーになるのはログインができていない可能性が高いのでログイン画面に遷移する
        history.push({ pathname: "/login", state: { err: RE_LOGIN_MESSAGE, } });
        //let jsonObject = JSON.parse(error);
      })
      .finally(() => {
        closeLoading()
      })

  }, []);

  const sumFileSize2 = ({ construction }: { construction: [] }) => {
    let subtotal = 0
    construction.forEach(item => {
      let size = (item as any)?.storage_size
      if (!isNaN(size)) {
        subtotal += parseInt(size)
      }
    })
    return subtotal.toString()
  }

  // 工事データから利用容量を算出
  // const storageRecalc = ({parent,child}:{parent:string,child:string}) => {
  const storageRecalc = ({ company }: { company: any }) => {
    const val_per = (capacity({ val: sumFileSize2({ construction: company.dealer_info }) }) / Number(company.total_capacity)) * 100
    if (val_per >= 50) setCapacityColor(['hide', '', 'hide'])
    if (val_per >= 90) setCapacityColor(['hide', 'hide', ''])
    setStoragePercentage(val_per)
  }

  // GBに変換
  const capacity = ({ val }: { val: string }) => {
    // const size = 64073000000 // インジケータ表示確認用
    const size = Number(val)
    const gb = 1024000000
    if (isNaN(size)) return 0
    // 表示単位はGB固定とし、小数点第二位まで表示
    const capacity_val = Math.floor((size / gb) * 10000) / 10000
    return capacity_val
  }



  /*配列データ*/
  const rows: any = [];
  posts.map((item) => (
    rows.push({ construction_name: item.construction_name, orderer: item.orderer, overview: item.overview, condate: moment(item.start_date).format('Y/MM/DD') + '〜' + moment(item.end_date).format('Y/MM/D'), storage: capacity({ val: item.storage_size }) + 'GB', conID: item.construction_id })
  ))

  /*詳細画面へ*/

  const Linkto = (e: any) => {

    history.push({
      pathname: "/Inspectionlist", state:
      {
        conid: e.conID,
      }
    });

  }
  /*詳細画面へ*/

  return (

    <GenericTemplate title="工事一覧">


      <Grid container spacing={3}>

        <Grid item sm={7} xs={12}>
          <Grid item sm={12} xs={12}>

          </Grid>
          <Grid item sm={12} xs={12}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              component={Link}
              to="/ConstructionCreat"
            >
              ＋ 工事新規作成
            </Button>
          </Grid>
        </Grid>

        <Grid item sm={3} xs={12} >
          <p className="storage-label bold">{capacity({ val: sumFileSize() })} GB / {companyPosts.total_capacity} GB</p>
        </Grid>

        <Grid item sm={2} xs={12}>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            className="bold"
            item sm={12} xs={12}>
            ストレージ容量
          </Grid>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            item sm={12} xs={12}>
            <BorderLinearProgress1 className={hide[0]} variant="determinate" value={storage_percentage} />
            <BorderLinearProgress2 className={hide[1]} variant="determinate" value={storage_percentage} />
            <BorderLinearProgress3 className={hide[2]} variant="determinate" value={storage_percentage} />
          </Grid>
        </Grid>

      </Grid>


      <ThemeProvider theme={theme}>
        <MaterialTable
          localization={localizationJapanese}
          options={{
            search: true,
            draggable: true,
            filtering: false,
            pageSize: 10,
            headerStyle: {
              backgroundColor: '#ececec',
              color: '#000',
              textAlign: "left",
              fontWeight: "600",
            },
          }}
          columns={[

            {
              title: '工事名',
              field: 'construction_name',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '発注者',
              field: 'orderer',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '概要',
              field: 'overview',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '工期',
              field: 'condate',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '使用容量',
              field: 'storage',
              cellStyle: {
                textAlign: "left",
              },
            },
          ]}
          data={rows}
          title="工事一覧"
          onRowClick={(event, rowData,) => Linkto(rowData)}
        />
      </ThemeProvider>

    </GenericTemplate>
  );
};

export default Constructionlist;